import React from 'react';
import { IconProps } from './types';

export const MarketInsightsIcon = (props: IconProps) => {
  const { size = 24, color = 'currentColor', style = {} } = props;

  return (
    <svg
      width={size}
      height={size}
      style={style}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M21 4H3C2.44772 4 2 4.44772 2 5V19C2 19.5523 2.44772 20 3 20H21C21.5523 20 22 19.5523 22 19V5C22 4.44772 21.5523 4 21 4Z'
        stroke={color}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path d='M16 12.5V16' stroke='#DFF60D' strokeLinecap='round' strokeLinejoin='round' />
      <path d='M12 8V16' stroke='#DFF60D' strokeLinecap='round' strokeLinejoin='round' />
      <path d='M8 10V16' stroke='#DFF60D' strokeLinecap='round' strokeLinejoin='round' />
    </svg>
  );
};
